/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_IdInputs */

const en_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Id`)
};

const fr_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de l’événement`)
};

const de_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis-ID`)
};

const it_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID evento`)
};

const ru_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор события`)
};

const es_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Id. de evento`)
};

const zh_cn2_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件 ID`)
};

const ja_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントID`)
};

const hi_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट आईडी`)
};

const pt_pt2_event_id = /** @type {(inputs: Event_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do evento`)
};

/**
* | output |
* | --- |
* | "Event Id" |
*
* @param {Event_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_id = /** @type {((inputs?: Event_IdInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_IdInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_id(inputs)
	if (locale === "de") return de_event_id(inputs)
	if (locale === "it") return it_event_id(inputs)
	if (locale === "ru") return ru_event_id(inputs)
	if (locale === "es") return es_event_id(inputs)
	if (locale === "zh-CN") return zh_cn2_event_id(inputs)
	if (locale === "ja") return ja_event_id(inputs)
	if (locale === "hi") return hi_event_id(inputs)
	if (locale === "pt-PT") return pt_pt2_event_id(inputs)
	return en_event_id(inputs)
});